import { MatButtonModule } from '@angular/material/button';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, ModuleWithProviders, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScriptService } from './services/script.service';
import { MigrationService } from './services/migration.service';
import { BaseApiService } from './services/base-api.service';
import { HttpXsrfInterceptor } from './interceptors/http-xsrf-interceptor';
import { UtilsService } from './services/utils.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({ declarations: [
    ],
    exports: [
    ], imports: [CommonModule,
        DragDropModule,
        MatDialogModule,
        MatTabsModule,
        MatIconModule,
        MatListModule,
        MatInputModule,
        MatRadioModule,
        MatButtonModule], providers: [
        HttpClient,
        ScriptService,
        MigrationService,
        BaseApiService,
        UtilsService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class OscUtilsModule {
  public static forRoot(): ModuleWithProviders<OscUtilsModule> {
    return {
      ngModule: OscUtilsModule,
      providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpXsrfInterceptor, multi: true }
      ]
    };
  }
}
